@if(data(); as data) {
    <div class="d-flex gap-5">
        <span
            (click)="openExportPackage()"
            stop-click-bubble
            role="button"
            class="font-5 primary-text">
            <svg-icon key="share" fontSize="1.5rem"></svg-icon>
        </span>
        @if (data?.canEdit()){
            <span
                (click)="editProject()"
                stop-click-bubble
                role="button"
                class="font-5 ms-2 primary-text">
                <svg-icon key="pencil" fontSize="1.5rem"></svg-icon>
            </span>
        }
        

        <span
            (click)="navigateToDetailPage()"
            stop-click-bubble
            role="button"
            class="font-5 ms-2 primary-text">
            <svg-icon key="folder-search" fontSize="1.5rem"></svg-icon>
        </span>
    </div>
}
